import { bootstrapApplication } from '@angular/platform-browser';
import { SupporterFeedbackAppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

bootstrapApplication(SupporterFeedbackAppComponent, appConfig).catch((err) =>
  console.error(err),
);
